module.exports = __webpack_public_path__ + "img/beijingicon.ac8bfa68.png";